<preview-item-context-menu></preview-item-context-menu>
<div #virtualGrid style="height: 0px;" class="flex flex-col relative">
    <ng-template #virtualGridRows></ng-template>
</div>
@if (items.count > 0) {
    <toggle-control-visibility></toggle-control-visibility>
}